__turbopack_context__.v({
  "accordionToggle": "AlexPlanScore-module-scss-module__iXGn9q__accordionToggle",
  "alexScoreHeader": "AlexPlanScore-module-scss-module__iXGn9q__alexScoreHeader",
  "cartContext": "AlexPlanScore-module-scss-module__iXGn9q__cartContext",
  "fade": "AlexPlanScore-module-scss-module__iXGn9q__fade",
  "fade-slide": "AlexPlanScore-module-scss-module__iXGn9q__fade-slide",
  "getStartedBtn": "AlexPlanScore-module-scss-module__iXGn9q__getStartedBtn",
  "isOpen": "AlexPlanScore-module-scss-module__iXGn9q__isOpen",
  "open-from-center": "AlexPlanScore-module-scss-module__iXGn9q__open-from-center",
  "planAlexScore": "AlexPlanScore-module-scss-module__iXGn9q__planAlexScore",
  "planScoreActions": "AlexPlanScore-module-scss-module__iXGn9q__planScoreActions",
  "planScoreBadge": "AlexPlanScore-module-scss-module__iXGn9q__planScoreBadge",
  "planScoreInfo": "AlexPlanScore-module-scss-module__iXGn9q__planScoreInfo",
  "planScoreProgress": "AlexPlanScore-module-scss-module__iXGn9q__planScoreProgress",
  "planScoreProgressBg": "AlexPlanScore-module-scss-module__iXGn9q__planScoreProgressBg",
  "planScoreProgressFill": "AlexPlanScore-module-scss-module__iXGn9q__planScoreProgressFill",
  "scoreExplanation": "AlexPlanScore-module-scss-module__iXGn9q__scoreExplanation",
  "spin": "AlexPlanScore-module-scss-module__iXGn9q__spin",
});
